import {
  CardAnimations,
  TopVodSimpleCard,
  VodSimpleCard,
} from '@setplex/arcana'
import { useCallback, type MouseEvent } from 'react'
import { useUnit } from 'effector-react'
import * as pinLockFeature from '~/features/pin-lock'
import type { ShowWithPrice } from '~/shared/interfaces'
import {
  VodCardHorizontalCoversMap,
  VodCardVerticalCoversMap,
} from '~/shared/ui/components/cardCovers'
import { type ViewRow } from '~/widgets/DynamicModule'
import { getCardContentPadding, getCategoryId } from '../lib'

export const TvShowCard = ({
  row,
  item,
  idx,
}: {
  row: ViewRow
  item: ShowWithPrice
  idx: number
}) => {
  const {
    landscapeImageUrl,
    portraitImageUrl,
    free,
    rented,
    locked,
    name,
    id,
    labelPrice,
    vertical,
  } = item

  const {
    appearance: {
      style: { posterSize, posterOrientation, topContent },
      resource: { search },
    },
  } = row

  const { isLocked, intercept } = useUnit({
    isLocked: pinLockFeature.$isLockedFn,
    intercept: pinLockFeature.intercept,
  })

  const contentPadding = getCardContentPadding(posterSize)

  const categoryId = getCategoryId(search)

  const handleShowCardClick = useCallback(
    (event: MouseEvent<Element>) => {
      event.preventDefault()
      event.stopPropagation()
      intercept({
        id,
        locked,
        name,
        '<event>': event,
      })
    },
    [intercept, id, locked, name]
  )

  const posterUrl =
    posterOrientation === 'HORIZONTAL' ? landscapeImageUrl : portraitImageUrl

  const covers =
    posterOrientation === 'HORIZONTAL'
      ? VodCardHorizontalCoversMap
      : VodCardVerticalCoversMap

  const Card = topContent ? TopVodSimpleCard : VodSimpleCard
  const topNumber = idx + 1

  return (
    <a href={`/content/series/${id}?categoryId=${categoryId}`}>
      <Card
        onClick={handleShowCardClick}
        childrenTransition={CardAnimations.FadeIn}
        lazyImage={false}
        type={posterOrientation}
        posterUrl={posterUrl}
        free={free}
        rented={rented}
        locked={isLocked({ id, locked })}
        title={name}
        purchaseTitle={labelPrice}
        contentPadding={contentPadding}
        covers={covers}
        verticalVideo={vertical}
        topNumber={topNumber}
      />
    </a>
  )
}
